import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import * as styles from './ThirdPartyServiceButton.css';

const cx = classNames.bind(styles);

const ThirdPartyServiceButton = ({ name }) => {
    const tpsConfig = {
        button: {
            className: 'capitalize p-1',
        },
        wrapper: {
            className: [
                'bg-white-100',
                'border-2',
                'border-gray-300',
                'border-r-0',
                'border-solid',
                'fixed',
                'flex',
                'font-open-sans-semibold',
                'items-center',
                'justify-center',
                'px-half py-1',
                'rounded-bl-small',
                'rounded-tl-small',
                'text-small',
                'text-third-party',
                'hidden',
                'z-10',
                cx(`${name}`, 'third-party-service'),
            ].join(' '),
            id: `tps-${name}-button`,
        },
    };

    return (
        <div {...tpsConfig.wrapper}>
            <button {...tpsConfig.button} type="button">
                {name}
            </button>
        </div>
    );
};

ThirdPartyServiceButton.propTypes = {
    name: string.isRequired,
};

export default ThirdPartyServiceButton;
